import webApi from "../WebApi/WebApi";

import webApi2 from "../WebApi/WebApi2";


export const getDistrictList = async () => {
    return await webApi2.post(`/api/GetDistrict`,);
}
export const getBlockList = async (data) => {
    return await webApi2.post(`/api/GetBlock/${data ? data : 0}`,);
}
export const getGpList = async (data) => {
    return await webApi2.post(`/api/GetGP/${data ? data : 0}`,);
}

export const getTotalAvailableFund = async (dist, block, gp, report) => {
    return await webApi.get(`/MIS/TotalAvailableFund?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&rptType=${report}`,);
}

export const getTotalTaxNonTaxAmount = async (
    dist,
    block,
    gp,
    report,
    frmDate,
    toDate
) => {
    return await webApi.get(
        `/MIS/TaxNonTaxAmount?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&rptType=${report}&frmDate=${frmDate}&toDate=${toDate}`
    );
};


export const getISGPPWiseReceipt = async (
    dist,
    block,
    gp,
    report,
    frmDate,
    toDate
) => {
    return await webApi.get(
        `/MIS/ISGPPWiseReceipt?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&rptType=${report}&frmDate=${frmDate}&toDate=${toDate}`
    );
};


export const getIsgppOsrHeadWisePayment = async (
    dist,
    block,
    gp,
    report,
    frmDate,
    toDate
) => {
    return await webApi.get(
        `/MIS/IsgppOsrHeadWisePayment?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&rptType=${report}&frmDate=${frmDate}&toDate=${toDate}`
    );
};


export const getIsgppSchemeWiseExpenditure = async (
    distLgd,
    blockLgd,
    gpLgd,
    rptType,
    frmDate,
    toDate
) => {
    return await webApi.get("/MIS/IsgppSchemeWiseExpenditure", {
        params: {
            distLgd: Number(distLgd) || 0,
            blockLgd: Number(blockLgd) || 0,
            gpLgd: Number(gpLgd) || 0,
            rptType: Number(rptType),
            frmDate,
            toDate,
        },
    });
};


